// @flow

import React, { useState } from 'react'

import mobile from '../Icons/icon-mobileupload-gray.svg'
import web from '../Icons/icon-desktopupload-gray.svg'

import './AppTypeFilter.css'

type Props = {
  changeFilter: Function,
  currentFilter: Function
}

function AppTypeFilter ({ changeFilter, currentFilter }: Props) {
  const filter = currentFilter && currentFilter.alt ? currentFilter.alt : ''
  const [selected, setSelected] = useState(filter)

  const handleClick = (type) => {
    if (selected === type) {
      setSelected('ALL')
      changeFilter(Object.assign({}, currentFilter, { alt: 'ALL' }))
      return
    }
    setSelected(type)
    changeFilter(Object.assign({}, currentFilter, { alt: type }))
  }

  return (
    <>
      <div className='Header'>
        <div>
          <span className='HeaderText'>Filter by App</span>
        </div>
      </div>

      <div className='FilterByContent'>
        <div className='FilterByRow'>
          <div className='FilterByColumn'>
            <ul>
              <li className='AppTypeIcon'><img src={mobile} alt='expand' /></li>
              <li className='AppTypeIcon'><img src={web} alt='expand' /></li>
            </ul>
          </div>
        </div>
        <div className='FilterByRow'>
          <div className='FilterByColumn'>
            <ul>
              <li
                key='Mobile'
                className={(selected === 'MOBILE') ? 'AppTypeItem selected' : 'AppTypeItem'}
                onClick={() => handleClick('MOBILE')}>Mobile App</li>
              <li
                key='Web'
                className={(selected === 'WEB') ? 'AppTypeItem selected' : 'AppTypeItem'}
                onClick={() => handleClick('WEB')}>Web App</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default AppTypeFilter
